<template>
  <div @click="clickItem">
    <card no-body
          shadow-size="sm"
          class="border-main-color" :class="{'cursor-pointer': isClickable}" style="border-width: 0 0 0 5px">
      <div class="row align-items-center mx-0">
        <div class="pl-5" style="flex: 1; min-width: 0; overflow: hidden;">
          <div class="mt-1"></div>
          <p class="m-0 text-custom-text font-weight-500 news-title">
            <span v-if="!isRead" class="unread-dot"></span>{{ item.title }}
          </p>
          <p class="m-0 font-size-13 text-custom-text mt-1 notification-body">{{ item.body }}</p>
          <p class="m-0 font-size-11 font-weight-500 text-custom-gray-2 mt-1">{{ formatDateOnly(item.created_at) }}</p>
          <div class="mt-1"></div>
        </div>
        <div v-if="isClickable" class="pr-5">
          <div>
            <i class="fa fa-angle-right fa-2x text-main-color" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>

import {formatDateOnly} from "@/util/formatter";
import * as Api from "@/util/http_api";

export default {
  name: "NotificationItem",
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      // 本地覆寫已讀狀態，點下去馬上讓小圓點消失，不必等重新查詢
      localRead: false,
    };
  },
  computed: {
    isRead() {
      return this.item.is_read || this.localRead;
    },
    // 帳款通知（type 2）點了去帳單頁；訂單異動等有型錄的通知去該型錄
    isBillNotification() {
      return Number(this.item.type) === 2;
    },
    isClickable() {
      return this.isBillNotification || !!this.item.catalog_id;
    },
  },
  methods: {
    formatDateOnly,
    async clickItem() {
      if (!this.isRead) {
        this.localRead = true;
        try {
          await Api.markNotificationRead(this.item.id);
          this.$emit('read', this.item);
        } catch (e) {
          // 標記失敗就還原，不要讓畫面顯示成已讀但實際上沒存到
          this.localRead = false;
          console.error(e);
        }
      }
      if (this.isClickable) {
        this.$emit('navigate', this.item);
        const target = this.isBillNotification ? {name: 'customer_bills'} : {name: 'commodity', params: {id: this.item.catalog_id}};
        this.$router.push(target).catch(() => {});
      }
    },
  },
}
</script>

<style scoped>
.news-title {
  white-space: normal;
  word-break: break-word;
}

.notification-body {
  /* 通知頁顯示全文，保留內文裡的換行與分段 */
  white-space: pre-line;
  word-break: break-word;
}

.unread-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #E89100;
  margin-right: 6px;
}
</style>
